"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaticSelect = void 0;
var react_1 = __importDefault(require("react"));
var SelectPresenter_1 = require("./components/SelectPresenter");
var useSelect_1 = require("./hooks/useSelect");
var StaticSelect = function (props) {
    var useSelectConfiguration = useSelect_1.useSelect(props);
    return react_1.default.createElement(SelectPresenter_1.SelectPresenter, __assign({}, props, useSelectConfiguration));
};
exports.StaticSelect = StaticSelect;
//# sourceMappingURL=StaticSelect.js.map